export const longest = {
  ...{ name: 60, notaTitle: 90, threadTitle: 80, nota: 280, rule: 500, reason: 500, question: 4000, attached: 10 },
  ...{ adMessage: 200, adHeadline: 40, adDescription: 35, link: 500 },
} as const;
